import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { emptyArray } from 'ui-components/default-props/empty';

import { Button } from 'ui-components/components/button';

import { DeletePackageSetModalWrapper } from './delete-package-set-modal';

import style from './multi-package-modal.module.less';

export const PackageSetsList = ({ applyPackageSetFromList, packageSetsList = emptyArray, packageSetsListClassName }) => {
  return (
    <DeletePackageSetModalWrapper>
      {({ openModal }) => {
        return (
          <DropdownMenu className={packageSetsListClassName}>
            <DropdownMenuToggler buttonSize='small' theme='link'>
              <FormattedMessage defaultMessage='Apply Package Set' description='multiPackageModal.addPackageSetButton' id='dgXkGy' />
            </DropdownMenuToggler>
            {packageSetsList.map((packageSetInList, index) => {
              return (
                <DropdownMenuItem key={index} className={style['package-set-dropdown']}>
                  <div className={style['package-set-button']}>
                    <div className={style['package-set-name']} onClick={() => applyPackageSetFromList(packageSetInList)}>
                      {packageSetInList.name}
                    </div>
                    <Button
                      className={style['x-button']}
                      onClick={() => openModal(packageSetInList.packageSetId, packageSetInList.name)}
                      theme='unstyled'
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </Button>
                  </div>
                </DropdownMenuItem>
              );
            })}
          </DropdownMenu>
        );
      }}
    </DeletePackageSetModalWrapper>
  );
};

PackageSetsList.propTypes = {
  applyPackageSetFromList: PropTypes.func.isRequired,
  packageSetsList: PropTypes.array,
};
